import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import KindlyForm from "./components/KindlyForm";

function Form() {
  return <KindlyForm />;
}

export default Form;
